import { Button, Image, LegacyCard, Space, Typography, useMessagedAsyncFn } from "@payping/web-components";
import FileSaver from "file-saver";
import JSZip from "jszip";
import { FC } from "react";
import { useAppSelector } from "@/utils/redux";
import { useAppTranslation } from "@/utils/useAppTranslation";
import { URLS } from "@payping/utilities-shared/consts";
import { buildUrl } from "@payping/utilities-shared/url";

const zip = new JSZip();

const GithubDonate: FC = () => {
  const { t } = useAppTranslation();
  const username = useAppSelector((state) => state.user.personalInfo?.username);

  const [{ loading }, createDonateFile] = useMessagedAsyncFn(
    async () => {
      const folder = zip.folder(".github");
      folder?.file("FUNDING.yml", `custom: ['${buildUrl(URLS.PPNG_URL, username).toString()}']`);
      await zip.generateAsync({ type: "blob" }).then((content: any) => {
        FileSaver.saveAs(content, "github-payping-donation.zip");
      });
    },
    [username],
    undefined,
    { useProgress: true },
  );

  return (
    <Space orientation="vertical">
      <Typography.Paragraph>{t("connections.plugins.featuredList.githubDonate.help")}</Typography.Paragraph>
      <Button loading={loading} key={"getToken"} type={"primary"} onClick={createDonateFile}>
        {t("services.detail.donate.githubDownload")}
      </Button>
      <LegacyCard.Ant>
        <Image src={`${URLS.STORAGE_URL}/payping-sponser.jpg`} alt={"githubDonate"} width={"100%"} height={"auto"} />
      </LegacyCard.Ant>
    </Space>
  );
};

export default GithubDonate;
